import { useEffect, useRef } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid"; // ya simple Math.random()
import ProductTabs from "../components/HomeSection/ProductTabs";
import CustomerReviews from "../components/HomeSection/CustomerReviews";
import { getWindowDimensions } from "../utils";

const FALLBACK_IMAGE =
  "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/product-placeholder.svg";

const SLIDES = [
  {
    id: 1,
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/heroBanner.jpeg",
    title: "Wear the Feeling",
    subtitle:
      "Designed for children who feel deeply. Crafted with love for parents who notice.",
    buttonText: "Explore Shop",
    buttonLink: "/shop",
  },
  {
    id: 6,
    title: "Little Wanderers",
    subtitle:
      "A world of tiny explorers. Storybook adventurers for curious little hearts.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/6/ChatGPTImageMay16202601_43_20P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/little-wanderers",
  },
  {
    id: 4,
    title: "Tiny Tropics",
    subtitle: "Beach days. Sunny ways. Tiny adventures.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/4/ChatGPTImageMay16202601_14_58P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/tiny-tropics",
  },
  {
    id: 5,
    title: "Adventure Trails",
    subtitle: "Little feet. Big adventures. Memories that last forever.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/5/ChatGPTImageMay16202601_07_30P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/adventure-trails",
  },
];

const CENTER_BANNERS = [
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/romper.png",
    title: "The First Feeling",
    description: "For the ones just beginning to discover the world.",
    link: "/shop?product_type=Romper",
    btnText: "Shop Collection",
  },
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/boy-tee.jpeg",
    title: "The Everyday Tee",
    description: "For the child who carries a whole world inside.",
    link: "/shop?product_type=TShirt",
    btnText: "Shop Collection",
  },
];

const BOTTOM_SLIDES = [
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/collection2.png",
    title: "Sun & Shenanigans",
    description: "For the ones just beginning to discover the world.",
    link: "/collections/sun-shenanigans",
    btnText: "Explore Collection",
  },
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/cloth.png",
    title: "The Difference is in the Details",
    description: "Every stitch. Every thread. Every feeling.",
    link: "/the-difference",
    btnText: "Our Story",
  },
];

const TRUST_ICONS = [
  {
    icon: (
      <img
        src="/assets/images/cash_in_hand.png"
        alt="Cash on Delivery"
        style={{ height: 50, width: 50, objectFit: "contain" }}
      />
    ),
    title: "Cash on Delivery",
    desc: "Pay When It Arrives. No Trust Issues!",
  },
  {
    icon: <i className="icon-delivery-time" />,
    title: "Quick Delivery",
    desc: "Estimated delivery time: 4–14 days across India.",
  },
  {
    icon: <i className="icon-door" />,
    title: "Instant Refunds",
    desc: "7-Day Easy return policy.",
  },
];

const ColumnSlides = ({
  slides = [],
  showBottomPadding = true,
  showTopPadding = true,
}) => {
  const paginationClass = useRef(
    `sw-pagination-${Math.random().toString(36).slice(2, 7)}`,
  );
  const isDesktop = getWindowDimensions().width >= 1368;

  return (
    <section
      className={`flat-spacing-12`}
      style={{
        paddingBottom: !showBottomPadding ? "0" : "",
        paddingTop: !showTopPadding ? "0" : "",
      }}
    >
      <div className="container">
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true, el: `.${paginationClass.current}` }}
          spaceBetween={25}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
          loop={false}
          className="tf-sw-collection"
        >
          {slides.map((slide, i) => (
            <SwiperSlide key={i}>
              <div className="half-img-box">
                <div className="collection-item-v4 style-2 hover-img">
                  <div className="collection-inner">
                    <a
                      href={slide.link}
                      className="collection-image img-style radius-0 o-hidden"
                    >
                      <img
                        loading="lazy"
                        decoding="async"
                        src={slide.image}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = FALLBACK_IMAGE;
                        }}
                        alt="collection-img"
                        style={{
                          height: isDesktop ? "100vh" : "100%",
                          width: "100%",
                          border: "2px solid white",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                          zIndex: 0,
                          border: "2px solid white",
                        }}
                      />
                    </a>
                    <div
                      className="collection-content wow fadeInUp"
                      data-wow-delay="0s"
                      style={{
                        visibility: "visible",
                        animationDelay: "0s",
                        animationName: "fadeInUp",
                      }}
                    >
                      <h5 className="heading fs-52 text-white ">
                        {slide.title}
                      </h5>
                      <p
                        className="fade-item fade-item-2 text_white"
                        dangerouslySetInnerHTML={{ __html: slide.description }}
                        style={{ display: "block" }}
                      />
                      <a
                        href={slide.link}
                        className="tf-btn btn-outline-light radius-4"
                        style={{ backgroundColor: "white" }}
                      >
                        <span style={{ marginRight: 10, color: "black" }}>
                          {slide.btnText}
                        </span>
                        <i
                          style={{ color: "black" }}
                          className="icon icon-arrow-right"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className={`sw-dots style-2 ${paginationClass.current} justify-content-center`}
        />
      </div>
    </section>
  );
};

const HomeV3 = () => {
  useEffect(() => {
    document.title = "Home | HueHoppers – Joyful Kids' Fashion";
  }, []);

  return (
    <>
      <style>{`
        @media (max-width: 1368px) {
          .half-img-box {
            width: 100%;
          }
            .collection-image {
              height: 100% !important;
            }
        }
          
      `}</style>
      <div className="px-0">
        <div className="tf-slideshow slider-home-2 slider-effect-fade position-relative">
          <Swiper
            modules={[Autoplay, Pagination, EffectFade]}
            effect="fade"
            loop={true}
            autoplay={{ delay: 5000 }}
            speed={1000}
            pagination={{
              clickable: true,
              el: ".sw-pagination-slider",
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
            }}
            slidesPerView={1}
            className="tf-sw-slideshow"
          >
            {SLIDES.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="wrap-slider" style={{ height: "100vh" }}>
                  <img
                    loading="lazy"
                    decoding="async"
                    src={slide.image}
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt={`banner-${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100vh",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                    }}
                  />
                  <div className="box-content">
                    <div className="container">
                      <h1 className="fade-item fade-item-1  text_white">
                        {slide.title.split(" for ").map((part, i) => (
                          <span key={i}>{part}</span>
                        ))}
                      </h1>
                      <p
                        className="fade-item fade-item-2  text_white"
                        dangerouslySetInnerHTML={{ __html: slide.subtitle }}
                        style={{ display: "block" }}
                      />
                      <div className="fade-item fade-item-3">
                        <Link
                          style={{
                            backgroundColor: "white",
                          }}
                          to={slide.buttonLink}
                          className="tf-btn btn-outline-light btn-xl radius-4"
                        >
                          <span style={{ color: "black" }}>
                            {slide.buttonText}
                          </span>
                          <i
                            style={{ color: "black" }}
                            className="icon icon-arrow-right"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="wrap-pagination pos2">
            <div className="container">
              <div className="sw-dots sw-pagination-slider dots-pagination dots-white justify-content-center" />
            </div>
          </div>
        </div>
      </div>
      <ProductTabs />

      <ColumnSlides slides={CENTER_BANNERS} showTopPadding={false} />
      <section
        className="banner-hero-collection-wrap banner-parallax"
        style={{
          minHeight: "500px",
          backgroundImage:
            "url('https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/mid-age-girl-child2.png')",
        }}
      >
        <div className="box-content">
          <div className="container">
            <a
              href="/shop"
              className="card-box text-md-start text-center rounded-0"
            >
              <h3 className="heading ">
                Expressing Mood. <br />
                Unfiltered.
              </h3>
              <p className="text">
                A collection that celebrates the full spectrum of childhood
                emotions, from joyful giggles to quiet contemplation. Each piece
                is designed to let little ones express their feelings freely and
                authentically.
              </p>
              <div
                className="wow fadeInUp"
                data-wow-delay="0s"
                style={{
                  visibility: "visible",
                  animationDelay: "0s",
                  animationName: "fadeInUp",
                }}
              >
                <button className="tf-btn rounded-0 style-2 btn-fill  animate-hover-btn">
                  <span>SHOP COLLECTION</span>
                </button>
              </div>
            </a>
          </div>
        </div>
      </section>
      <ColumnSlides slides={BOTTOM_SLIDES} showBottomPadding={false} />
      <section className="flat-spacing-12">
        <div className="container">
          <div className="flat-iconbox-v3 lg mw-1100">
            <div className="wrap-carousel wrap-mobile">
              <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true, el: ".sw-pagination-mb" }}
                spaceBetween={15}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 3 },
                }}
                className="tf-sw-mobile"
              >
                {TRUST_ICONS.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className="tf-icon-box text-center">
                      <div className="icon">{item.icon}</div>
                      <div className="content">
                        <div className="title ">{item.title}</div>
                        <p className="text_black-2">{item.desc}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="sw-dots style-2 sw-pagination-mb justify-content-center" />
            </div>
          </div>
        </div>
      </section>

      <CustomerReviews shownOnHome={true} />
      <section className="flat-spacing-5">
        <div className="container">
          <div
            className="flat-title wow fadeInUp"
            data-wow-delay="0s"
            style={{
              visibility: "visible",
              animationDelay: "0s",
              animationName: "fadeInUp",
            }}
          >
            <span className="title ">Shop Instagram</span>
            <p className="sub-title">
              Follow{" "}
              <strong>
                <a
                  href="https://www.instagram.com/huehoppers26/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @huehoppers26
                </a>
              </strong>{" "}
              on Instagram
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default HomeV3;
